import React, {
  forwardRef,
  useCallback,
  useEffect,
  useImperativeHandle,
  useRef,
  useState,
} from "react";
import { current } from "@reduxjs/toolkit";
import data from "../../json/Querytemplate.json";
import { toast } from "react-toastify";
import { useDispatch } from "react-redux";
import { icons } from "antd/es/image/PreviewGroup";
import { setQueryLength } from "../../reducer/slice";

const Querycomp = React.memo(
  ({
    i,
    items,
    id,
    setPendingQueryId,
    selectQueryInEditor,
    handleEditorClick,
    setCurrentQuery,
    pendingQueryId,
    currentQuery,
    setQuerylist,
    querylist,
    updateQueryInRefOutput,
    editor,
    deleteQueryFromEditor,
  }) => {
    const [commentText, setCommentText] = useState("");
    const [showAddComment, setShowAddComment] = useState(false);
    const [currentMore, setCurrentMore] = useState(null);
    const [currentEdit, setCurrentEdit] = useState(null);
    const [selectedIndex, setSelectedIndex] = useState(""); //For select state update
    const morepopup = useRef();
    const textareaRef = useRef(null);
    const queryRef = useRef(null);

    useEffect(() => {
      if (textareaRef.current) {
        textareaRef.current.focus();
      }
    }, []);

    useEffect(() => {
      const handleClickOutside = (event) => {
        if (
          morepopup.current &&
          !morepopup.current.contains(event.target) &&
          !event.target.closest(".morebtn")
        ) {
          // Your logic to close the popup
          setCurrentMore(null);
        }
        if (!queryRef.current.contains(event.target)) {
          setCurrentEdit(null);
        }
      };
      document.addEventListener("mousedown", handleClickOutside);
      return () => {
        document.removeEventListener("mousedown", handleClickOutside);
      };
    }, []);

    const handleTextChange = (e) => {
      let input = e.target.value;
      setCommentText(input);
    };

    const finalizeQuery = (id) => {
      if (commentText.trim() === "") return;
      setQuerylist((prev) =>
        prev.map((q) =>
          q.queryid === id
            ? {
                ...q,
                comments: [
                  ...q.comments,
                  {
                    name: "User",
                    id: q.comments.length++,
                    comment: commentText,
                    selectedIndex: selectedIndex,
                  },
                ],
              }
            : q
        )
      );
      setCommentText("");
      setSelectedIndex("");
      setShowAddComment(false)
      setPendingQueryId(null);
    };

    const editQuery = (id, index) => {
      if (commentText.trim() === "") return;

      const updatedList = querylist.map((q) =>
        q.queryid === id
          ? {
              ...q,
              comments: q.comments.map((comment, i) =>
                i === index
                  ? {
                      ...comment,
                      comment: commentText.trim(),
                      selectedIndex,
                    }
                  : comment
              ),
            }
          : q
      );

      setQuerylist(updatedList);
      updateQueryInRefOutput(editor, id, updatedList);

      setCommentText("");
      setSelectedIndex("");
      setCurrentEdit(null);
    };

    const handleAddComment = (id) => {
      setShowAddComment(true);
      setSelectedIndex("")
       setCommentText("");
      // setCurrentQuery(id);
    };

    const handleMore = (queryid, i) => {
      if (currentMore === i) {
        setCurrentMore(null);
      } else {
        setCurrentMore(i);
      }
    };

    const handleQueryDelete = (type, id, i) => {
      if (type === "0") {
        setQuerylist((prev) => prev.filter((e) => e.queryid !== id));
        deleteQueryFromEditor(id);
      } else if (type === "1") {
        setQuerylist((prev) =>
          prev.map((ele) => {
            if (ele.queryid === id) {
              return {
                ...ele,
                comments: ele.comments.filter((e) => e.id !== i),
              };
            }
            return ele;
          })
        );
      }
    };

    const handlequerySelect = (id) => {
      setCurrentQuery(id);
      selectQueryInEditor(id);
    };

    const Select = ({ selectindex }) => {
      const valueToUse = selectedIndex !== null ? selectedIndex : selectindex;

      return (
        <select
          onClick={(e) => e.stopPropagation()}
          onChange={(e) => {
            const index = e.target.value;
            setSelectedIndex(index);
            setCommentText(data[index].content);
          }}
          className="w-full cursor-pointer outline-none"
          value={valueToUse}
        >
          <option value="" disabled>
            -- Select an option --
          </option>
          {data.map((q, i) => (
            <option key={i} value={i}>
              {q.heading}
            </option>
          ))}
        </select>
      );
    };

    return (
      <div
        id={id}
        key={i}
        ref={queryRef}
        onClick={() => handlequerySelect(items.queryid)}
        className={`w-full h-fit p-3 rounded-[8px] flex flex-col gap-5 cursor-pointer ${
          items.queryid === currentQuery || items.queryid === pendingQueryId
            ? "bg-[#d1d1d1]"
            : "bg-[white]"
        }`}
      >
        {items?.comments?.length === 0 ? (
          <>
            <div className="flex items-center gap-2">
              <div className="h-2 w-2 bg-[red]  mt-[2px] rounded-full"></div>
              <p>{items?.createdBy}</p>
            </div>
            <div className="w-full h-fit flex flex-col gap-2">
              <Select selectindex={null} />
              <textarea
                ref={textareaRef}
                value={commentText}
                className="w-full p-2 h-[120px] outline-none"
                onChange={handleTextChange}
              ></textarea>
              <div className="flex gap-3 justify-end mt-2">
                <button
                  onClick={handleEditorClick}
                  className="bg-[#E3E3E3] px-3 py-1 rounded-[6px]"
                >
                  Cancel
                </button>
                <button
                  onClick={() => finalizeQuery(items.queryid)}
                  className="bg-hovergrey text-white px-3 py-1 rounded-[6px] hover:bg-primary"
                >
                  Save
                </button>
              </div>
            </div>
          </>
        ) : (
          <div className="flex flex-col">
            {items?.comments?.map((c, i) => (
              <div
                key={i}
                onClick={() => setCurrentQuery(c.queryid)}
                className={`flex flex-col pb-3  gap-3 ${
                  items.queryid === currentQuery ||
                  items.queryid === pendingQueryId
                    ? "bg-[#d1d1d1] border-white border-b"
                    : "bg-white"
                }  ${i == 0 ? "" : "pt-3"} ${
                  items?.comments?.length - 1 !== i &&
                  (items.queryid !== currentQuery ||
                    items.queryid !== pendingQueryId)
                    ? "border-[#d1d1d1] border-b"
                    : ""
                } ${items?.comments?.length - 1 == i ? "border-none" : ""}`}
              >
                <div
                  key={i}
                  className="flex items-center gap-5 justify-between relative"
                >
                  <div className="flex items-center gap-2">
                    <div className="h-2 w-2 bg-[red] mt-[2px] rounded-full"></div>
                    <p className="text-20 font-semibold">{c.name}</p>
                  </div>
                  <button
                    onClick={() => handleMore(items.queryid, i)}
                    className="p-1 hover:bg-[#E3E3E3] rounded-[8px] relative morebtn"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      className="icon icon-tabler icons-tabler-outline icon-tabler-dots"
                    >
                      <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                      <path d="M5 12m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0" />
                      <path d="M12 12m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0" />
                      <path d="M19 12m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0" />
                    </svg>
                  </button>
                  {items.queryid === currentQuery && currentMore === i && (
                    <div
                      ref={morepopup}
                      className="absolute top-[80%] right-0 flex flex-col gap-2 px-3 py-1 bg-white items-start z-10"
                    >
                      {i === 0 ? (
                        <button
                          onClick={() =>
                            handleQueryDelete("0", items.queryid, i)
                          }
                        >
                          Delete Query
                        </button>
                      ) : (
                        <button
                          onClick={() =>
                            handleQueryDelete("1", items.queryid, i)
                          }
                        >
                          Delete
                        </button>
                      )}
                      <button
                        className="w-full text-left"
                        onClick={() => {
                          setCurrentEdit(i);
                          setCurrentMore(null);
                          setShowAddComment(false);
                          setSelectedIndex(c.selectedIndex);
                          setCommentText(c.id === i ? c.comment : "");
                        }}
                      >
                        Edit
                      </button>
                    </div>
                  )}
                </div>
                <div className="flex flex-col gap-2">
                  {currentEdit === i ? (
                    <div className="w-full h-fit flex flex-col gap-2">
                      <Select selectindex={c.selectedIndex} />
                      <textarea
                        ref={textareaRef}
                        // value={
                        //   commentText === ""
                        //     ? c.id === i
                        //       ? c.comment
                        //       : ""
                        //     : commentText
                        // }
                        value={commentText}
                        className="w-full p-2 h-[120px] outline-none"
                        onChange={handleTextChange}
                      ></textarea>
                      <div className="flex gap-3 justify-end mt-2">
                        <button
                          onClick={() => {
                            setCurrentEdit(null);
                          }}
                          className="bg-[#f0f0f0] px-3 py-1 rounded-[6px] hover:bg-[#e0e0e0]"
                        >
                          Cancel
                        </button>
                        <button
                          onClick={() => editQuery(items.queryid, i)}
                          className="bg-hovergrey text-white px-3 py-1 rounded-[6px] hover:bg-primary"
                        >
                          Save
                        </button>
                      </div>
                    </div>
                  ) : (
                    <p className="text-[16px]">{c.comment}</p>
                  )}
                </div>
              </div>
            ))}
            {showAddComment && items.queryid === currentQuery && (
              <div className="w-full h-fit flex flex-col gap-2 mt-2">
                <Select selectindex={null} />
                <textarea
                  ref={textareaRef}
                  value={commentText}
                  className="w-full p-2 h-[120px] outline-none"
                  onChange={handleTextChange}
                ></textarea>
                <div className="flex gap-3 justify-end mt-2">
                  <button
                    onClick={() => {
                      setShowAddComment(false);
                      setCurrentQuery(null);
                    }}
                    className="bg-[#f0f0f0] px-3 py-1 rounded-[6px] hover:bg-[#e0e0e0]"
                  >
                    Cancel
                  </button>
                  <button
                    onClick={() => finalizeQuery(items.queryid)}
                    className="bg-hovergrey text-white px-3 py-1 rounded-[6px] hover:bg-primary"
                  >
                    Save
                  </button>
                </div>
              </div>
            )}
            {!showAddComment &&
            currentQuery === items.queryid &&
            typeof currentEdit !== "number" ? (
              <button
                onClick={() => handleAddComment(items.queryid)}
                className="w-full h-fit text-[14px] font-bold p-[6px] bg-white justify-center flex text-black rounded-[8px] mt-2 hover:bg-[#e0e0e0]"
              >
                Add Comment...
              </button>
            ) : (
              <></>
            )}
          </div>
        )}
      </div>
    );
  }
);

const Query = forwardRef(
  (
    { editor, setShowQuery, showQuery, setShowPopup, setQueryIds, isShow },
    ref
  ) => {
    const [popupPosition, setPopUpPosition] = useState({ top: 0, left: 0 });
    const [popupvisible, setPopUpVisible] = useState(false);
    const [selectedText, setSelectedText] = useState();
    const [querylist, setQuerylist] = useState([]);
    const [showTextBox, setShowTextBox] = useState(false);
    const [pendingQueryId, setPendingQueryId] = useState(null);
    const [currentQuery, setCurrentQuery] = useState(null);
    // const [commentText, setCommentText] = useState("");
    const dispatch = useDispatch();

    useImperativeHandle(ref, () => ({
      addQuery: (data) => {
        setQuerylist((prev) => [...prev, data]);
      },
      removeQuery: (id) => {
        setQuerylist((prev) => [
          ...prev.filter((item) => (item?.refId ? item?.refId !== id : true)),
        ]);
      },
      handleAddQuery: handleQuery,
      handleEditClick: handleEditorClick,
      handleCheckQuery: handleCheckQuery,
    }));

    // Text selection and popup for query selection

    editor?.on("MouseUp", () => {
      const selection = editor.selection;
      const text = selection.getContent({ format: "text" }).trim();

      if (text && !popupvisible) {
        updatePopUpPosition();
        setPopUpVisible(true);
        setSelectedText(text);
      } else {
        setPopUpVisible(false);
      }
    });

    //   editor?.on("click", () => setPopUpVisible(false));

    editor?.on("init", () => {
      const iframeDoc = editor.iframeElement?.contentDocument;

      if (iframeDoc) {
        iframeDoc.addEventListener("scroll", updatePopUpPosition);
      }
    });

    const cleanQueryList = () => {
      if (!editor) return;

      const dom = editor.dom;

      // Get all <query> tags from editor
      const queryElements = dom.select("query");
      // Extract all query IDs present in the editor
      const editorQueryIds = queryElements.map((el) =>
        el.getAttribute("data-query-id")
      );

      // Filter querylist to keep only items whose queryid exists in editorQueryIds
      setQuerylist((prevList) =>
        prevList.filter((item) => editorQueryIds.includes(item.queryid))
      );
    };

    const updatePopUpPosition = () => {
      if (!editor) return;

      const selection = editor.selection;

      if (!selection || !selection.getRng) return;

      const text = selection.getContent({ format: "text" }).trim();
      if (!text) return;

      const rect = selection.getRng().getBoundingClientRect();
      const range = selection.getRng();

      if (text.length > 50) {
        setPopUpPosition({
          top: rect.top + 40,
          left: range.startOffset,
        });
      } else {
        setPopUpPosition({
          top: rect.top + 40,
          left: rect.left,
        });
      }
    };

    function generateRandomId(existingIds, prefix = "") {
      let id;
      do {
        id = prefix + Math.random().toString(36).substr(2, 5);
      } while (existingIds.includes(id));
      return id;
    }

    function removeQueryFromRefOutput(editor, queryId) {
      // Get all <ref> elements
      const allRefs = editor.dom.select("ref");

      allRefs.forEach((ref) => {
        // Find the <refoutput> inside this ref
        // const refOutput = editor.dom.select("refoutput", ref)[0];
        // if (refOutput) {
        // Try to find the <query> inside this refOutput
        const queryTag = editor.dom.select(
          `query[data-query-id="${queryId}"]`,
          ref
        )[0];
        if (queryTag) {
          editor.dom.remove(queryTag); // Remove the <query> tag
        }
        // }
      });
    }

    function updateQueryInRefOutput(editor, queryId, querylist) {
      const queryObj = querylist.find((q) => q.queryid === queryId);
      if (!queryObj) return;

      const latestComment =
        queryObj.comments.length > 0
          ? queryObj.comments[queryObj.comments.length - 1].comment
          : "";

      const allRefs = editor.dom.select("ref");

      allRefs.forEach((ref) => {
        // const refOutput = editor.dom.select("refoutput", ref)[0];
        // if (!refOutput) return;

        const queryTag = editor.dom.select(
          `query[data-query-id="${queryId}"]`,
          ref
        )[0];

        if (queryTag) {
          const queryFirst = editor.dom.select("queryfirst", queryTag)[0];

          if (queryFirst) {
            // Remove all siblings after <queryfirst>
            let sibling = queryFirst.nextSibling;
            while (sibling) {
              const toRemove = sibling;
              sibling = sibling.nextSibling;
              queryTag.removeChild(toRemove);
            }

            // Add the new comment as text node after <queryfirst>
            queryTag.append(
              editor.getDoc().createTextNode(" " + latestComment)
            );
          }
        }
      });
    }

    function handleQuery(selection) {
      const existingIds = querylist.map((q) => q.queryid);

      let id = generateRandomId(existingIds);
      const lastId = existingIds[existingIds.length - 1];
      setTimeout(() => {
        let ele = document.getElementById(`query-panel-${lastId}`);

        ele.scrollIntoView({ behavior: "smooth", block: "center" });
      }, 100);
      setShowPopup(false);

      // If `selection` is passed, it will be an array of elements
      if (selection && Array.isArray(selection) && selection.length > 0) {
        let refId;

        selection.forEach((refCit) => {
          refId = refCit.getAttribute("rid");
          const text = refCit.textContent.trim();

          if (!text) {
            toast.warn("Selected element has no content");
            return;
          }
          // const commentHTML = `<query data-query-id="${id}">${text}</query> `;
          const commentHTML = text;
          editor.dom.replace(
            editor.dom.create("query", { "data-query-id": id }, commentHTML),
            refCit
          );
        });

        // setCommentText("The citation do not have any reference");
        // Add to query list
        setQuerylist((prev) => [
          ...prev,
          {
            queryid: id,
            refId: refId,
            createdBy: "currentUser",
            comments: [],
          },
        ]);
      } else {
        // Default behavior if `selection` is not provided
        const text = editor.selection.getContent({ format: "text" }).trim();
        if (!text) {
          toast.warn("Please select a text");
          return;
        }

        const commentHTML = `<query data-query-id="${id}">${text}</query> `;
        editor.selection.setContent(commentHTML);

        setQuerylist((prev) => [
          ...prev,
          { queryid: id, createdBy: "currentUser", comments: [] },
        ]);
      }

      setPendingQueryId(id);
      setCurrentQuery(null);
      if (setShowQuery) setShowQuery(true);
    }

    const handleEditorClick = (e) => {
      setCurrentQuery(null);
      let el = e.target;

      if (el && el.nodeName === "QUERY") {
        const queryId = el.getAttribute("data-query-id");
        console.log(queryId, "query");

        if (queryId) {
          setShowQuery(true);
          setCurrentQuery(queryId);
          setTimeout(() => {
            let ele = document.getElementById(`query-panel-${queryId}`);

            ele.scrollIntoView({ behavior: "smooth", block: "center" });
          }, 100);
        }
      }

      if (!pendingQueryId || !editor) return;

      const queryObj = querylist.find((q) => q.queryid === pendingQueryId);

      if (queryObj && queryObj.comments.length === 0) {
        const dom = editor.dom;

        // Find the <query> element by its data-query-id
        const queryEl = dom.select(
          `query[data-query-id="${pendingQueryId}"]`
        )[0];

        if (queryEl) {
          // Replace the <query> element with its text content
          const textNode = editor.getDoc().createTextNode(queryEl.innerText);
          queryEl.parentNode.replaceChild(textNode, queryEl);

          setQuerylist((prev) =>
            prev.filter((q) => q.queryid !== pendingQueryId)
          );
          setPendingQueryId(null);
        }
      }
    };

    const deleteQueryFromEditor = (id) => {
      if (!editor && !id) {
        return;
      }

      if (editor && id) {
        const dom = editor.dom;
        removeQueryFromRefOutput(editor, id);

        const queryEle = dom.select(`query[data-query-id="${id}"]`)[0];

        if (queryEle) {
          const textNode = editor.getDoc().createTextNode(queryEle.innerText);
          queryEle.parentNode.replaceChild(textNode, queryEle);
        }
      }
    };

    const selectQueryInEditor = (id) => {
      if (!editor && !id) {
        return;
      }
      if (editor && id) {
        const dom = editor.dom;

        const queryEle = dom.select(`query[data-query-id="${id}"]`)[0];

        if (queryEle) {
          editor.selection.select(queryEle);
          // Optionally scroll it into view
          editor.selection.scrollIntoView(queryEle, true);
          //  editor.focus(); // Make sure the editor is focused
        }
      }
    };

    const handleCheckQuery = () => {
      if (!editor || !editor.dom) {
        return;
      }
      const dom = editor.dom;

      // 1. Get all <query> elements from the editor
      const queryElements = dom.select?.("query") || [];

      queryElements.forEach((el) => {
        let queryId = el.getAttribute("data-query-id");
        const queryFirst = editor.dom.select("queryfirst", el)[0];

        // If no data-query-id, generate one and set it on the tag
        if (!queryId) {
          const existingIds = querylist.map((q) => q.queryid);
          queryId = generateRandomId(existingIds);
          el.setAttribute("data-query-id", queryId);

          const commentText =
            el.textContent?.trim() || el.innerHTML?.trim() || "";

          const updated = {
            queryid: queryId,
            refId: "",
            createdBy: "Editor",
            comments: [{ name: "Editor", id: 0, comment: commentText }],
          };

          setQuerylist((prev) => [...prev, updated]);
        }

        // If <queryfirst> is missing, add it and move text before it
        if (!queryFirst) {
          // Create <queryfirst> tag
          const tag = editor.dom.create(
            "queryfirst",
            { "data-edit": "queryFirst", class: "queryFirst" },
            "Q."
          );

          // Insert <queryfirst> before any existing content
          if (el.firstChild) {
            el.insertBefore(tag, el.firstChild);
          } else {
            // If <query> is empty, just append
            el.appendChild(tag);
          }
        }
      });
    };

    useEffect(() => {
      if (editor) {
        editor?.on("Click", handleEditorClick);
      }

      return () => {
        if (editor) {
          editor?.off("Click", handleEditorClick);
        }
      };
    }, [editor, pendingQueryId, querylist, handleEditorClick]);

    useEffect(() => {
      if (querylist) {
        const existingIds = querylist.map((q) => q.queryid);
        setQueryIds(existingIds);

        dispatch(setQueryLength(querylist.length));
        // querylist.length < 1 ? setShowQuery(false) : <></>;
      }
    }, [querylist]);

    useEffect(() => {
      if (showQuery) {
        cleanQueryList();
      }
    }, [showQuery]);

    // useEffect(() => {
    //   return () => {
    //     const iframeDoc = editor?.iframeElement?.contentDocument;
    //     if (iframeDoc) {
    //       iframeDoc.removeEventListener("scroll", updatePopUpPosition);
    //     }
    //   };
    // }, []);

    return (
      <div
        className={`w-full  flex-col gap-4 ${
          isShow === "query" ? "flex" : "hidden"
        }`}
      >
        <div className="flex flex-col gap-4">
          {querylist.length ? (
            querylist.map((items, i) => (
              <Querycomp
                key={items.queryid}
                items={items}
                id={`query-panel-${items.queryid}`}
                setQuerylist={setQuerylist}
                setPendingQueryId={setPendingQueryId}
                querylist={querylist}
                selectQueryInEditor={selectQueryInEditor}
                handleEditorClick={handleEditorClick}
                setCurrentQuery={setCurrentQuery}
                currentQuery={currentQuery}
                pendingQueryId={pendingQueryId}
                deleteQueryFromEditor={deleteQueryFromEditor}
                editor={editor}
                updateQueryInRefOutput={updateQueryInRefOutput}
              />
            ))
          ) : (
            <>
              <h4 className="mt-5 text-center font-semibold text-[18px]">
                No Query Available
              </h4>
            </>
          )}
        </div>
        {/* {popupvisible && (
        <div
          style={{
            position: "absolute",
            top: popupPosition.top,
            left: popupPosition.left,
            background: "white",
            border: "1px solid #ccc",
            padding: "6px 10px",
            borderRadius: "4px",
            boxShadow: "0 2px 6px rgba(0,0,0,0.2)",
            zIndex: 0,
          }}
        >
          <button
            onClick={() => {
              setShowQuery(true);
              setPopUpVisible(false);
              handleQuery();
            }}
          >
            Create Query
          </button>
        </div>
      )} */}
      </div>
    );
  }
);

export default Query;
